const palette = [
  '#ffd9c2', '#ffe2b8', '#fff1b8', '#dcefc4', '#c6ead8', '#c6e3ec',
  '#cdd9f1', '#dccff1', '#ecc8e0', '#f3c8c8', '#f1d4b8', '#d8d2c2',
];

export function getAvatarColor(name: string): string {
  const letter = (name.trim()[0] ?? '?').toUpperCase();
  const idx = letter.charCodeAt(0) % palette.length;
  return palette[idx] ?? palette[0];
}

export function getAvatarInitial(name: string): string {
  return (name.trim()[0] ?? '?').toUpperCase();
}

/**
 * Up to two initials: the first letters of the first and last words ("Meet
 * Soni" → "MS"). Words split on spaces, dots, underscores and hyphens, so an
 * email local part reads the same way ("meet.soni" → "MS"). One word → one
 * letter.
 */
export function getAvatarInitials(name: string): string {
  const words = name.trim().split(/[\s._-]+/).filter(Boolean);
  if (words.length === 0) return '?';
  const first = words[0]![0]!;
  const last = words.length > 1 ? words[words.length - 1]![0]! : '';
  return (first + last).toUpperCase();
}
